import { Box } from "@mui/material"
import { UserCircleGear } from "@phosphor-icons/react"
import React, { ReactNode } from "react"
import { Agent } from "../../types/Agent"

interface CallCardHeaderProps {
  agent: Agent
  right?: ReactNode
  secondary?: ReactNode
}

export function CallCardHeader({
  agent,
  right,
  secondary,
}: CallCardHeaderProps) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 5,
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        columnGap: {
          xs: "var(--spacing-tokens-size-in-px-spacing-spacing-md)",
          sm: "var(--spacing-tokens-size-in-px-spacing-spacing-2xl)",
        },
        rowGap: "var(--spacing-tokens-size-in-px-spacing-spacing-md)",
        padding: {
          xs: "var(--spacing-tokens-size-in-px-spacing-spacing-xl)",
          sm: "var(--spacing-tokens-size-in-px-spacing-spacing-2xl)",
        },
        background: "var(--call-header-scrim)",
        pointerEvents: "none",
        "& > *": { pointerEvents: "auto" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: {
            xs: "var(--spacing-tokens-size-in-px-spacing-spacing-md)",
            sm: "var(--spacing-tokens-size-in-px-spacing-spacing-lg)",
          },
          flex: "1 1 0",
          minWidth: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            padding: "var(--spacing-tokens-size-in-px-spacing-spacing-md)",
            borderRadius: "var(--spacing-tokens-size-in-px-radius-radius-full)",
            border: "none",
            backgroundColor: "var(--call-avatar-button-bg)",
            color: "var(--color-foreground-fg-white)",
          }}
        >
          <UserCircleGear size={20} />
        </Box>
        <Box
          sx={{
            fontFamily: "var(--app-font-family, figtree, sans-serif)",
            fontSize: "var(--global-heading-xs-semi-bold-font-size)",
            fontWeight: "var(--global-heading-xs-semi-bold-font-weight)",
            lineHeight:
              "calc(var(--global-heading-xs-semi-bold-line-height) * 1px)",
            color: "var(--color-text-text-white)",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          Chat with {agent?.name || "Agent"}
        </Box>
      </Box>

      {secondary && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            flexShrink: 0,
            order: { xs: 1, sm: 0 },
            flexBasis: { xs: "100%", sm: "auto" },
          }}
        >
          {secondary}
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: {
            xs: "var(--spacing-tokens-size-in-px-spacing-spacing-md)",
            sm: "var(--spacing-tokens-size-in-px-spacing-spacing-2xl)",
          },
          flexShrink: 0,
        }}
      >
        {right}
      </Box>
    </Box>
  )
}
